{
  "unnamed": "Your golfer",
  "age_line": "Age {age}",
  "path": {
    "real_handicap": "Started from a real handicap",
    "beginner": "New to the game",
    "junior": "Started as a junior golfer",
    "senior": "Started as a senior golfer",
    "random_life": "A life drawn at random",
    "elite_amateur": "An elite amateur",
    "tour_pro": "A professional"
  },
  "purpose": {
    "kicker": "Right now",
    "rust": "Shaking off the rust.",
    "first_round": "Getting ready for a first round.",
    "next_round": "Building towards the next round."
  },
  "level": {
    "label": "Playing level",
    "explain": "The game's estimate today",
    "rust": "Includes {rust} of rust",
    "handicap_label": "FL Handicap",
    "handicap_none": "Not yet",
    "handicap_explain": "Starts after your first counting cards."
  },
  "fact": {
    "best": "Best area",
    "weakest": "To work on",
    "curve": "Natural curve",
    "energy": "Energy"
  },
  "number_line": "{name} {number}, {label}",
  "spoken_number": "{name}, {number} out of 100, {label}",
  "curve": {
    "draw": "Draw",
    "fade": "Fade",
    "straight": "Straight",
    "detail_right": "Right-handed. {shape, select, draw {The stock full shot moves gently left.} fade {The stock full shot moves gently right.} other {The stock full shot flies straight.}}",
    "detail_left": "Left-handed. {shape, select, draw {The stock full shot moves gently right.} fade {The stock full shot moves gently left.} other {The stock full shot flies straight.}}"
  },
  "skills": {
    "title": "Skills",
    "open": "See all skills",
    "close": "Hide the skills",
    "caption": "Out of 100, with one decimal place",
    "areas": "12 areas",
    "all": "19 skills",
    "switch_label": "Show skills as",
    "measured": "How your golfer is measured: each number is out of 100. The words say who plays like that."
  },
  "life": {
    "title": "Life story",
    "open": "Read the life story",
    "close": "Hide the life story",
    "empty": "Your golfer's story starts with their first milestone.",
    "hidden": "Hidden. Only you can see it."
  },
  "profile": {
    "grades_title": "Skill grades",
    "grades_open": "See the skill grades",
    "grades_close": "Hide the skill grades",
    "grades_caption": "Other golfers' skills show as grades, never as numbers.",
    "grade_line": "{name}: grade {grade}",
    "level_label": "Playing level",
    "life_title": "Life story",
    "back": "Back"
  },
  "error": "Your golfer did not load. Your golfer is safe.",
  "retry": "Try again",
  "loading": "Loading your golfer",
  "none_title": "No golfer yet",
  "none_body": "Make your golfer, and their skills and story will show here.",
  "none_action": "Make your golfer",
  "no_server_body": "Your golfer shows here once this build can reach the game's server."
}
